"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const DOM_1 = require("./DOM");
const Random_1 = require("./Random");
var Modal;
(function (Modal) {
    class Config {
        static modalElementClass = 'customDesign-modals';
        static hideModalClassName = "hide";
        static modalCloseElementClass = "triggerModalClose";
        static modalErrorElement = "customDesign-modals-content-error";
    }
    class Helpers {
        static getShownModal() {
            const modalElements = DOM_1.DOM.Parser.getHtmlElements(Config.modalElementClass, undefined, true);
            for (let i = 0; i < modalElements.length; i++) {
                const modal = modalElements[i];
                if (!modal.classList.contains(Config.hideModalClassName)) {
                    return modal;
                }
            }
            return null;
        }
        static closeModalByElement(modalElement) {
            modalElement.classList.add(Config.hideModalClassName);
        }
        static closeModalById(id) {
            this.closeModalByElement(DOM_1.DOM.Parser.getHtmlElement(id));
        }
        static openModalByElement(modalElement) {
            modalElement.classList.remove(Config.hideModalClassName);
        }
        static openModalById(id) {
            this.openModalByElement(DOM_1.DOM.Parser.getHtmlElement(id));
        }
        static initModalTriggersByModalElement(modal, onClose) {
            const modalError = DOM_1.DOM.Parser.getHtmlElementByClass(Config.modalErrorElement, modal);
            const randomString = (0, Random_1.getRandomString)(5);
            modalError.classList.add(`selector-${randomString}`);
            modalError.dataset.selector = `selector-${randomString}`;
            DOM_1.DOM.Parser.getHtmlElementByClass(Config.modalCloseElementClass, modal).addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                if (onClose) {
                    onClose(modal);
                }
                this.closeModalByElement(modal);
            });
        }
        static initModalTriggersByModalId(modalId, onClose) {
            this.initModalTriggersByModalElement(DOM_1.DOM.Parser.getHtmlElement(modalId), onClose);
        }
    }
    Modal.Helpers = Helpers;
})(Modal || (exports.Modal = Modal = {}));
